export const SPANISH_MONTHS = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export const SPANISH_MONTHS_SHORT = [
  "Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic",
];

export function formatEUR(n, { signed = false } = {}) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const v = Number(n);
  const sign = signed && v > 0 ? "+" : "";
  return sign + new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
    useGrouping: "always",
  }).format(v);
}

export function formatEURDecimal(n, { signed = false } = {}) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const v = Number(n);
  const sign = signed && v > 0 ? "+" : "";
  return sign + new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: "always",
  }).format(v);
}

export function formatNumber(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("es-ES", { maximumFractionDigits: 0, useGrouping: "always" }).format(Number(n));
}

export function formatDate(d) {
  if (!d) return "—";
  try {
    return new Intl.DateTimeFormat("es-ES", { dateStyle: "medium", timeStyle: "short" }).format(new Date(d));
  } catch (e) {
    return String(d);
  }
}
